import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import { translate, isNullOrEmpty } from '../../../../../utils/util';
import * as pabReplanningAction from '../../../../../actions/pabReplanningAction';
import { ENUMS } from '../../../../../utils/constants';

const SmallPartsFilterByTask = (props) => {
    const [task, setTask] = useState('');
    let inputFilter;

    useEffect(() => {
        inputFilter.focus();
    }, [inputFilter]);

    const applyFilter = () => {
        if (!isNullOrEmpty(task)) {
            props.filter.orderItemCode = task;
            props.filter.orderType = ENUMS.eOrderType.PabReplanning.value;
            props.filter.excludeOrderGrouped = true;
            props.filter.allOrders = true;
            props.setFilterOrder(props.filter);
            // Redirect para tela de Orders
            props.history.push({
                pathname: '../orders',
                state: {
                    printerLabel: true
                }
            });
        }
    };

    const subtitlesPickingFilterByOrder = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('line-picking:linepicking.filterByTask') }];
    }

    return (
        <div>
            <Breadcrumbs id="pickingFilterByOrder" subtitles={subtitlesPickingFilterByOrder()} />
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="col s12">
                        <input
                            id="txtTask"
                            ref={(el) => inputFilter = el}
                            placeholder={translate('line-picking:linepicking.task')}
                            type="number"
                            onChange={(event) => { setTask(event.currentTarget.value); }}
                            maxLength="20"
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <button
                        type="button"
                        className="col s12 m3
                        btn
                        btn-principal
                        waves-effect
                        waves-light"
                        onClick={() => applyFilter()}
                    >
                        {translate('apply', 'general')}
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.pabReplanningReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterOrder: (filter) => {
            dispatch(pabReplanningAction.setFilter(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsFilterByTask)));
